import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import App from "../App.vue";
import Quiz from "../components/QuizFuckOff.vue";
import Decrypt from "../components/DecryptFuckOff.vue";
import FixLights from "../components/FixLightsFuckOff.vue";
import Adventure from "../components/AdventureFuckOff.vue";
import Congrats from "../components/CongratsFuckOff.vue";
import ChooseTask from "@/components/ChooseTask.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  { path: "/", redirect: "/home" },
  { path: "/home", name: "home", component: ChooseTask },
  { path: "/quiz", name: "quiz", component: Quiz },
  { path: "/decrypt", name: "decrypt", component: Decrypt },
  { path: "/fix-lights", name: "fix-lights", component: FixLights },
  { path: "/adventure", name: "adventure", component: Adventure },
  { path: "/congrats", name: "congrats", component: Congrats },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
